const topics = [
  {
    title: "Forms of Energy",
    slug: "formsofenergy",
    standardNumber: "5.2",
    description: "Force, Motion, and Energy – Energy exists in many forms like chemical, mechanical, nuclear, electrical, light, motion, and sound, all fitting into potential or kinetic energy.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fformsofenergy2025video.mp4?alt=media&token=1f91096f-e36f-4a25-96a6-048c26433725",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fformsofenergy2025song.mp3?alt=media&token=5101cfce-2f00-468b-b7c4-89b48eec32cf",
    lyrics: ["(chorus)",
"Different forms of energy.",
"Potential and kinetic,", 
"potential and kinetic.", 
"Different forms of energy.",
"Potential and kinetic,", 
"potential and kinetic.",

"(verse 1)",
"Chemical energy is stored in gas and coal.", 
"Stored in the bonds of atoms and molecules.", 
"Mechanical energy is stored in things",
"that have tension, like rubber bands and springs.", 
"Nuclear energy is stored in the nucleus of an atom.", 
"It can be released in large amounts.",
"Electrical energy is stored in a battery.",
"It can start my car or power up my T.V.",

"(chorus)",
"Different forms of energy.",
"Potential and kinetic,", 
"potential and kinetic.", 
"Different forms of energy.",
"Potential and kinetic,", 
"potential and kinetic.", 

"(verse 2)",
"Electromagnetic energy is radiant energy,", 
"light, x-rays, radio waves.",
"Motion energy is stored in movement.",
"You get more energy the faster it's moving.", 
"Sound energy is energy through waves,", 
"made when a force cause something to vibrate.",

"(chorus)",
"Different forms of energy.",
"Potential and kinetic,", 
"potential and kinetic.", 
"Different forms of energy.",
"Potential and kinetic,", 
"potential and kinetic.",

"© Smart Board Learning, LLC. All rights reserved.",],
    gameType: "multipleChoice",
    titleImage: "",
  },
  {
    title: "Energy Transfer",
    slug: "energytransfer",
    standardNumber: "5.2",
    description: "Force, Motion, and Energy – Energy can change from one form to another, such as light to electrical, chemical to thermal, or electrical to sound and light.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fenergytransfer2025video.mp4?alt=media&token=58831dcb-2eb4-4dee-9fee-27e5162a433f",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fenergytransfer2025song.mp3?alt=media&token=831ddaef-afbe-4240-ae45-2f6e75dfab3e",
    lyrics: ["(chorus)",
"Let’s transform that energy, transform that energy,",
"transform that energy, transform.",
"Let’s transform that energy, transform that energy,",
"transform that energy, transform.",

"(verse)",
"You can connect solar panels lots of things,",
"and it will change light energy into electrical energy.",
"A T.V. changes electrical energy into light energy,",
"and a T.V. changes electrical energy into sound energy.",
"Let’s see what kind of energy makes a car move.",
"There’s chemical energy inside the fuel,",
"and it turns into thermal and mechanical energy.",
"The batteries in a flashlight have chemical energy.",
"and when it’s turned on, what do you see? You see the light energy.",
"Now, plain old wood has potential chemical energy.",
"Put fire to the wood and it turns into thermal energy for cooking and heat.",

"(chorus)",
"Let’s transform that energy, transform that energy,",
"transform that energy, transform.",
"Let’s transform that energy, transform that energy,",
"transform that energy, transform.",

"© Smart Board Learning, LLC. All rights reserved.",],
    gameType: "multipleChoice",
    titleImage: "",
  },
  {
    title: "Energy",
    slug: "energy",
    standardNumber: "5.3",
    description: "Force, Motion, and Energy – Energy comes in many forms like heat, sound, and light, but all can be grouped into kinetic energy in motion or potential energy stored.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fenergy2025video.mp4?alt=media&token=ceaf4bd0-ada4-4c29-8186-72cd4c542281",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fenergy2025song.mp3?alt=media&token=016e8787-4fa9-48da-b49a-b1e08da24502",
    lyrics: ["(chorus)",
"Kinetic energy is energy in motion, energy in motion,",
"Potential energy is stored energy, stored energy,",
"Kinetic energy is energy in motion, energy in motion,",
"Potential energy is stored energy, stored energy,",
"(verse1)",
"Now energy is found in many different forms, right?,",
"You’ve got heat, motion, sound, and light,",
"and they all can be placed into two categories,",
"That’s kinetic and potential energy,",
"(chorus)",
"Kinetic energy is energy in motion, energy in motion,",
"Potential energy is stored energy, stored energy,",
"Kinetic energy is energy in motion, energy in motion,",
"Potential energy is stored energy, stored energy,",
"(verse2)",
"Now energy is found in many different forms. Are we clear?,",
"You’ve got electrical, thermal, chemical, and nuclear,",
"and they all can be placed into two categories,",
"That’s kinetic and potential energy,",
"(chorus)",
"Kinetic energy is energy in motion, energy in motion,",
"Potential energy is stored energy, stored energy,",
"Kinetic energy is energy in motion, energy in motion,",
"Potential energy is stored energy, stored energy.",
"© Smart Board Learning, LLC. All rights reserved.",],
    gameType: "multipleChoice",
    titleImage: "",
  },
  {
    title: "Motion",
    slug: "motion",
    standardNumber: "5.3",
    description: "Force, Motion, and Energy – Motion happens when an object changes its position, whether moving a short distance or continuously traveling like a car on the highway.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fmotion2025video.mp4?alt=media&token=90933e74-b520-41d9-8d19-f01f4a9a2204",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fmotion2025song.mp3?alt=media&token=42c2ef01-e708-4c1a-bd92-80c832b82230",
    lyrics: ["(Chorus)",
"If an object changes its position,",
"Then a motion has occurred.",
"If it continuously changes its position,",
"Then it's in motion, then it's in motion.",

"(Verse)",
"Use a car as an example, and the car is parked at the curb.",
"Now, you move the car up 10 feet, then a motion has occurred.",
"Now, if you take the same parked car and put it on the highway,",
"Then start coasting.",
"Its position is constantly changing.",
"Then, it's in motion, then it's in motion.",

"(Chorus)",
"If an object changes its position,",
"Then a motion has occurred.",
"If it continuously changes its position,",
"Then it's in motion, then it's in motion.",
"If an object changes its position,",
"Then a motion has occurred.",
"If it continuously changes its position,",
"Then it's in motion, then it's in motion.",

"© Smart Board Learning, LLC. All rights reserved.",],
    gameType: "multipleChoice",
    titleImage: "",
  },
  {
    title: "Friction",
    slug: "friction",
    standardNumber: "5.3",
    description: "Force, Motion, and Energy – Friction is the resistance to motion between two objects that creates heat, like when you rub your hands together.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Ffriction.mp4?alt=media&token=0b166429-a2ea-49cf-aec5-5df0a1b10ff5",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Ffrictionrock.mp3?alt=media&token=f516d8b5-bc4d-4edf-85a5-3938d9ad24df",
    lyrics: ["(chorus)",
"The resistance to motion is friction.",
"The resistance to motion is friction.",

"(verse)",
"Made by two objects moving against each other, each other.",
"Made by two objects moving against each other, each other.",
"Friction creates heat.",
"Friction creates heat.",
"When you rub your hands together",
"you cause a resistance to motion,",
"then you feel heat from friction, from friction.",

"(chorus)",
"The resistance to motion is friction.",
"The resistance to motion is friction.",

"© Smart Board Learning, LLC. All rights reserved.",],
    gameType: "multipleChoice",
    titleImage: "",
  },
  {
    title: "Conductors",
    slug: "conductors",
    standardNumber: "5.4",
    description: "Force, Motion, and Energy – Conductors let electricity flow easily while insulators block the flow, with examples like copper and gold for conductors and rubber and styrofoam for insulators.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fconductors2025video.mp4?alt=media&token=575ccfe3-62fb-426b-ad44-5882b54eb356",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fconductors2025song.mp3?alt=media&token=1c1e3505-da36-40da-ae69-d7daa4f17d19",
    lyrics: ["(chorus)",
"Conductors and insulators.",
"Conductors and insulators.",
"Conductors and insulators.",
"Conductors and insulators.",

"(verse 1)",
"What makes materials conduct electricity?",
"When electrons jump.",
"What makes materials conduct electricity?",
"When electrons jump from one atom,",
"into an empty space of another atom.",
"The moving of electrons causes electrical currents.",
"Insulator, a material that electrical charges cannot move through,",
"cannot move through.",
"Conductor, a material that electrical charges easily flow through,",
"flow through.",
"Copper, conductor.",
"Gold, conductor.",
"Rubber, insulator.",
"Styrofoam, insulator.",

"(chorus)",
"Conductors and insulators.",
"Conductors and insulators.",
"Conductors and insulators.",
"Conductors and insulators.",

"© Smart Board Learning, LLC. All rights reserved.",],
    gameType: "dragDrop",
    titleImage: "",
  },
  {
    title: "Circuits",
    slug: "circuits",
    standardNumber: "5.4",
    description: "Force, Motion, and Energy – A circuit is the path electricity takes, flowing only in closed circuits and moving through series or parallel paths.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fcircuits2025video.mp4?alt=media&token=78828d71-caa2-4e97-aac9-a5680f38cb37",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fcircuits2025song.mp3?alt=media&token=8a8e26ab-6a16-4a36-9534-eb2d9133af8b",
    lyrics: ["(chorus)",
"A circuit is the path that electricity takes.",
"A circuit is the path that electricity takes.",
"A circuit is the path that electricity takes.",
"A circuit is the path that electricity takes.",

"(verse)",
"Electricity can only flow through a closed circuit.",
"Electricity cannot flow through an open circuit.",
"Series circuits have only one path",
"for electricity to flow, electricity to flow.",
"Parallel circuits have more than one path",
"for electricity to flow, electricity to flow.",

"(chorus)",
"A circuit is the path that electricity takes.",
"A circuit is the path that electricity takes.",
"A circuit is the path that electricity takes.",
"A circuit is the path that electricity takes.",

"© Smart Board Learning, LLC. All rights reserved.",],
    gameType: "multipleChoice",
    titleImage: "",
  },
  {
    title: "Sound Vibration",
    slug: "soundvibration",
    standardNumber: "5.5",
    description: "Force, Motion, and Energy – Sound is created by vibrations, such as guitar strings or vocal cords, that make the air move and produce noise we can hear.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fsoundvibration2025video.mp4?alt=media&token=cb99546b-37d4-4f3f-a966-0ce7a9d81ce3",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fsoundvibration2025song.mp3?alt=media&token=db451312-dd9d-4c4c-babe-357802dc1d67",
    lyrics: ["(chorus)",
"If you did not know where sound came from, well now you know.",
"It’s from the vibration, it’s from the vibration.",
"If you did not know where sound came from, well now you know.",
"It’s from the vibration, it’s from the vibration.",

"(verse)",
"When you grab your guitar and pluck on the string,",
"Listen to the sound, it makes you want to sing.",
"Vibration, vibration, vibration, vibration.",
"You can speak very soft or speak very loud.",
"Your vocal cords vibrate producing sound.",
"Vibration, vibration, vibration, vibration.",

"(chorus)",
"If you did not know where sound came from, well now you know.",
"It’s from the vibration, it’s from the vibration.",
"If you did not know where sound came from, well now you know.",
"It’s from the vibration, it’s from the vibration.",

"© Smart Board Learning, LLC. All rights reserved.",],
    gameType: "multipleChoice",
    titleImage: "",
  },
  {
    title: "Traveling Sound",
    slug: "travelingsound",
    standardNumber: "5.5",
    description: "Force, Motion, and Energy – Sound travels fastest through solids, slower through liquids, and slowest through gases because of how closely molecules are packed.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Ftravelingsoundvideo.mp4?alt=media&token=c45e82f5-788d-42f9-b61f-9fd6196461f1",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Ftravelingsound.mp3?alt=media&token=98b9625a-0777-4fdf-9e6c-bef05a6c4029",
    lyrics: ["(chorus)",
"Which one does sound travel through faster, solids, liquids, or gases?",
"Which one does sound travel through faster, solids, liquids, or gases?",

"(verse)",
"Through solids sound travels fastest.",
"Sound travels slowest through gases.",
"In solids the molecules are touching,",
"so, sound can just jump from one molecule to another.",
"In gases molecules are so far apart,",
"it takes time and energy for one molecule to touch another.",
"So, sound can only jump from molecule to another when they collide.",
"Gases take the longest time.",

"(chorus)",
"Which one does sound travel through faster, solids, liquids, or gases?",
"Which one does sound travel through faster, solids, liquids, or gases?",

"© Smart Board Learning, LLC. All rights reserved.",],
    gameType: "multipleChoice",
    titleImage: "",
  },
  {
    title: "Wave Properties",
    slug: "waveproperties",
    standardNumber: "5.5",
    description: "Force, Motion, and Energy – Waves have properties such as frequency, wavelength, amplitude, and period that describe their size, speed, and timing.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fwaveproperties2025video.mp4?alt=media&token=2b8e0b62-2ffd-4f97-9736-18b84f63c2bc",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fwaveproperties2025song.mp3?alt=media&token=bb4409fd-4bf7-4c37-9a5d-bf10dfb2ada7",
    lyrics: ["(Chorus)",
"Let’s name some properties of waves, of waves, of waves.",
"Let’s name some properties of waves, of waves, of waves.",
"Let’s name some properties of waves, of waves, of waves.",
"Let’s name some properties of waves, of waves, of waves.",

"(Verse)",
"Frequency is the number of waves,",
"That pass a point in a second.",

"Wavelength, the distance between the crest,",
"And by meters it’s measured.",

"Amplitude, the height of the wave,",
"The height of the joint.",

"Period, the time it takes,",
"For one complete wave to pass a given point.",

"(Chorus)",
"Let’s name some properties of waves, of waves, of waves.",
"Let’s name some properties of waves, of waves, of waves.",
"Let’s name some properties of waves, of waves, of waves.",
"Let’s name some properties of waves, of waves, of waves.",

"© Smart Board Learning, LLC. All rights reserved.",],
    gameType: "multipleChoice",
    titleImage: "",
  },
  {
    title: "Compression",
    slug: "compression",
    standardNumber: "5.5",
    description: "Force, Motion, and Energy – Sound travels as a compression wave, a type of longitudinal wave that moves through solids, liquids, and gases.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fcompression.mp4?alt=media&token=660ff280-99be-4dcb-943c-e05c90892fdd",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fcompression.mp3?alt=media&token=eec336b0-53af-4c8f-bbef-25fdf472da78",
    lyrics: ["(chorus)",
"When sound travels through matter,",
"it’s in a compression wave, it’s in a compression wave.",
"When sound travels through matter,",
"it’s in a compression wave, it’s in a compression wave.",

"(verse)",
"Compression waves are longitudinal waves.",
"Compression waves are longitudinal waves.",
"Compression waves travel through solids, liquids, and gases.",
"Compression waves travel through solids, liquids, and gases.",
"Compression waves move backwards and forwards",
"in the same direction the wave is traveling.",
"Compression waves travels through solids.",
"Compression waves travels through liquids.",
"Compression waves travels through gases.",
"Compression waves travels through gases.",

"(chorus)",
"When sound travels through matter,",
"it’s in a compression wave, it’s in a compression wave.",
"When sound travels through matter,",
"it’s in a compression wave, it’s in a compression wave.",

"© Smart Board Learning, LLC. All rights reserved.",],
    gameType: "dragDrop",
    titleImage: "",
  },
  {
    title: "Reflection",
    slug: "reflection",
    standardNumber: "5.6",
    description: "Force, Motion, and Energy – Reflection happens when light bounces off surfaces, with smooth surfaces like mirrors creating clear reflections and rough surfaces scattering light.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Freflection.mp4?alt=media&token=941f3949-28fd-4da2-8b49-f1c6b872e96b",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Freflection.mp3?alt=media&token=22c49135-0a84-4b23-b1e6-5e22ccdca99c",
    lyrics: ["(chorus)",
"Reflection happens when light bounces,",
"off an object, off an object,",
"Reflection happens when light bounces,",
"off an object, off an object,",
"(verse)",
"You get more reflection from smooth surfaces,",
"just like a mirror, just like a mirror,",
"If the surface of the object is rough,",
"then the light scatters, then the light scatters,",
"You get more reflection from smooth surfaces,",
"just like a mirror, just like a mirror,",
"If the surface of the object is rough,",
"then the light scatters, then the light scatters,",
"(chorus)",
"Reflection happens when light bounces,",
"off an object, off an object,",
"Reflection happens when light bounces,",
"off an object, off an object.",
"© Smart Board Learning, LLC. All rights reserved.",],
    gameType: "multipleChoice",
    titleImage: "",
  }, {
    title: "Refraction",
    slug: "refraction",
    standardNumber: "5.6",
    description: "Force, Motion, and Energy – Refraction happens when light changes speed and bends as it moves between air, water, or other materials.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Frefraction.mp4?alt=media&token=2c69c4e5-cd91-4c02-a1d2-0a413eb7a86d",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Frefraction.mp3?alt=media&token=8091af32-0d34-4189-9c82-1454930bccaf",
    lyrics: ["(chorus)",
"Refraction is the bending of light,",
"Refraction is the bending of light,",
"Refraction is the bending of light,",
"Refraction is the bending of light,",
"(verse)",
"When light hits the air it’s moving fast,",
"going on a straight path,",
"But what happens when it hits water?",
"Light slows down and bends on a new path,",
"Now, as light goes back into the air,",
"it speeds up and bends back again,",
"That’s refraction,",
"Refraction is when light bends,",
"(chorus)",
"Refraction is the bending of light,",
"Refraction is the bending of light.",
"© Smart Board Learning, LLC. All rights reserved.",],
    gameType: "multipleChoice",
    titleImage: "",
  },
  {
    title: "Transverse",
    slug: "transverse",
    standardNumber: "5.6",
    description: "Force, Motion, and Energy – A transverse wave is described by its wavelength, crest, and trough, which show the distance, highest point, and lowest point of the wave.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Ftransverse.mp4?alt=media&token=61e8730d-eebf-4952-beac-8cd0d52825da",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Ftransverse.mp3?alt=media&token=7195a6d8-ee64-421a-a1c4-cc345364a457",
    lyrics: ["[chorus]",
"In a transverse wave you have the wavelength, the crest and the trough.",
"In a transverse wave you have the wavelength, the crest and the trough.",

"[verse]",
"The wavelength is the distance between the crests and is measured by meters.",
"The wavelength is the distance between the crests and is measured by meters.",

"The crest is the highest point of the wave,",
"the crest is the highest point of the wave",

"The trough is the lowest point of the wave,",
"the trough is the lowest point of the wave",

"[chorus]",
"In a transverse wave you have the wavelength, the crest and the trough.",
"In a transverse wave you have the wavelength, the crest and the trough.",

"© Smart Board Learning, LLC. All rights reserved.",],
    gameType: "multipleChoice",
    titleImage: "",
  },
  {
    title: "Matter",
    slug: "matter",
    standardNumber: "5.7",
    description: "Matter – Matter has mass and volume and can be solid, liquid, or gas depending on how its particles are arranged and move.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fmatterrock2025video.mp4?alt=media&token=9dcb63a2-cfea-49ca-8cc7-0d30700ecab3",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fmatterrock2025song.mp3?alt=media&token=78f1e7a9-8c65-4b5a-8489-430d502eb06c",
    lyrics: ["(Chorus)",
"Matter has mass and takes up space.",
"Matter has mass and takes up space.",
"Three states of matter,",
"Solid, liquid, and gas.",
"Three states of matter,",
"Solid, liquid, and gas.",

"(Verse)",
"Solids, they keep their shape.",
"Solids, they keep their shape.",
"Particles are packed tightly in solids, vibrating.",
"Particles are packed tightly in solids, vibrating.",

"Liquids take the shape of its container.",
"Liquids take the shape of its container.",
"Particles are spread out a little, sliding past each other.",
"Particles are spread out a little, sliding past each other.",

"In gases, the shape will change with its container.",
"In gases, the volume will change with its container.",
"Particles are spread out and move very quickly.",
"Particles are spread out and move very quickly.",

"(Chorus)",
"Matter has mass and takes up space.",
"Matter has mass and takes up space.",
"Three states of matter,",
"Solid, liquid, and gas.",
"Three states of matter,",
"Solid, liquid, and gas.",

"© Smart Board Learning, LLC. All rights reserved.",],
    gameType: "multipleChoice",
    titleImage: "",
  },
  {
    title: "3 States of Matter",
    slug: "3statesofmatter",
    standardNumber: "5.7",
    description: "Matter – Matter makes up everything around us and exists in three states—solids, liquids, and gases.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2F3statesofmatter2025video.mp4?alt=media&token=a521644b-b4eb-4a56-89e2-2beb95c71ad7",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2F3statesofmatter2025song.mp3?alt=media&token=4ca634b8-d275-41d6-9e49-36d59970db1b",
    lyrics: ["(Chorus)",
"Matter is everything around you.",
"Matter is made of atoms and molecules.",
"3 states: solids, liquids, gases.",
"3 states: solids, liquids, gases.",

"(Verse)",
"Solids, yes, are hard.",
"Liquids are more like water.",
"Gases are like the atmosphere,",
"That surrounds the earth, our air.",
"Solids, yes, are hard.",
"Liquids are more like water.",
"Gases are like the atmosphere,",
"That surrounds the earth, our air.",
"Those are the 3 states of matter,",
"Those are the 3 states of matter.",
"Solids, liquids, gases.",
"Solids, liquids, gases.",

"(Chorus)",
"Matter is everything around you.",
"Matter is made of atoms and molecules.",
"3 states: solids, liquids, gases.",
"3 states: solids, liquids, gases.",

"© Smart Board Learning, LLC. All rights reserved.",],
    gameType: "multipleChoice",
    titleImage: "",
  },
  {
    title: "Atoms",
    slug: "atoms",
    standardNumber: "5.7",
    description: "Matter – Atoms are the smallest particles of matter made of protons, neutrons, and electrons arranged in the nucleus and orbitals.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fatoms.mp4?alt=media&token=fa704dc0-3c39-4a4c-b9a4-c2f912212d28",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fatoms2025song.mp3?alt=media&token=717cc6c2-e7ba-48b2-a09a-607d6ce2735e",
    lyrics: ["(Chorus)",
"Atoms, the smallest particles of matter.",
"Atoms, the smallest particles of matter.",

"They’re made of protons (positive),",
"Electrons (negative),",
"And neutrons (no charge, no charge).",
"They’re made of protons (positive),",
"Electrons (negative),",
"And neutrons (no charge, no charge).",

"(Verse)",
"Protons and neutrons are in the center of an atom",
"Called the nucleus.",
"Electrons float around the nucleus",
"In its orbitals.",
"Protons and neutrons are in the center of an atom",
"Called the nucleus.",
"Electrons float around the nucleus",
"In its orbitals.",

"(Chorus)",
"Atoms, the smallest particles of matter.",
"Atoms, the smallest particles of matter.",

"They’re made of protons (positive),",
"Electrons (negative),",
"And neutrons (no charge, no charge).",

"© Smart Board Learning, LLC. All rights reserved.",],
    gameType: "multipleChoice",
    titleImage: "",
  },
  {
    title: "Plate Boundaries",
    slug: "plateboundaries",
    standardNumber: "5.8",
    description: "Earth and Space Systems – Plate boundaries can converge, diverge, or transform, causing earthquakes, volcanoes, and the formation of new landforms.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fplateboundaries.mp4?alt=media&token=51168963-3aef-47e4-a49e-bb876aa20f72",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fplateboundaries.mp3?alt=media&token=6e76419b-3bed-418b-82f4-27b5d668f775",
    lyrics: ["[chorus]",
"At the boundary there will be earthquakes and volcanoes.",
"At the boundary there will be earthquakes and volcanoes.",
"At the boundary there will be earthquakes and volcanoes.",
"At the boundary there will be earthquakes and volcanoes.",

"[verse]",
"Plate boundaries can move together.",
"When they move together it’s convergent.",
"Plate boundaries can move together",
"causing volcanoes to erupt and earthquakes.",

"Plate boundaries can move apart.",
"When they move apart it’s divergent.",
"Plate boundaries can move apart",
"to form submarine mountains, earthquakes and",
"cause volcanic eruptions.",

"Plate boundaries can slide past each other.",
"Sliding boundaries are called transform boundaries.",
"Plate boundaries can slide past each other",
"and their known to create earthquakes,",
"known to create earthquakes.",

"[chorus]",
"At the boundary there will be earthquakes and volcanoes.",
"At the boundary there will be earthquakes and volcanoes.",
"At the boundary there will be earthquakes and volcanoes.",
"At the boundary there will be earthquakes and volcanoes.",

"© Smart Board Learning, LLC. All rights reserved.",
],
    gameType: "multipleChoice",
    titleImage: "",
  },
  {
    title: "My Three Rocks",
    slug: "mythreerocks",
    standardNumber: "5.8",
    description: "Earth and Space Systems – Sedimentary, igneous, and metamorphic rocks form in different ways through layers, cooling lava, heat, and pressure.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fmythreerocks2025video.mp4?alt=media&token=0138a21e-1381-437b-b9d1-87552c3cb5cb",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fmythreerocks2025song.mp3?alt=media&token=38261703-9b39-477d-977e-e13ce5c01b5a",
    lyrics: ["(chorus)",
"My three rocks.",
"Sedimentary, igneous, and metamorphic.",

"(verse)",
"Sedimentary rocks are formed in layers, formed in layers.",
"Sedimentary rocks are found near water,",
"Some have fossils and found near water.",

"Igneous rocks were here since the beginning.",
"Igneous rocks hot, lava cooled and hardened.",

"When you transform sedimentary and igneous rocks",
"With pressure, they make metamorphic rocks.",
"When you transform sedimentary and igneous rocks",
"With heat, they make metamorphic rocks.",

"(chorus)",
"My three rocks.",
"Sedimentary, igneous, and metamorphic.",
"My three rocks.",
"Sedimentary, igneous, and metamorphic.",

"© Smart Board Learning, LLC. All rights reserved.",],
    gameType: "multipleChoice",
    titleImage: "",
  },
  {
    title: "Rock Cycle",
    slug: "rockcycle",
    standardNumber: "5.8",
    description: "Earth and Space Systems – The rock cycle explains how igneous, sedimentary, and metamorphic rocks continuously form and change through cooling, heat, pressure, and erosion.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Frockcycle.mp4?alt=media&token=2d994c5a-af61-4d84-8a6e-f5b72a291aad",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Frockcycle.mp3?alt=media&token=5ee1fe41-6be8-49e2-822d-bf00672b585e",
    lyrics: ["(chorus)",
"The rock cycle can't stop and don’t stop.",
"The rock cycle can't stop and don’t stop.",

"(verse)",
"All rocks on this earth are made up of the same stuff,",
"even though all rocks are not the same, not the same.",
"You've got igneous rocks, and they can change",
"into sedimentary rocks, and they can change",
"into metamorphic rocks, and they can change",
"into igneous rock.",
"Rock cycle",

"(chorus)",
"The rock cycle can't stop and don’t stop.",
"The rock cycle can't stop and don’t stop.",

"(verse)",
"When magma cools and make crystals, it forms igneous rocks.",
"Those rocks break apart into sediments, making sedimentary rock.",
"When that rock is heated it changes its form.",
"Metamorphosis is what it’s called.",
"That's metamorphic rock and it can break down into sediments, making sedimentary rock.",

"(chorus)",
"The rock cycle can't stop and don’t stop.",
"The rock cycle can't stop and don’t stop.",

"© Smart Board Learning, LLC. All rights reserved.",],
    gameType: "multipleChoice",
    titleImage: "",
  },
  {
    title: "Surface Change",
    slug: "surfacechange",
    standardNumber: "5.8",
    description: "Earth and Space Systems – Earth’s surface changes through weathering, erosion, earthquakes, and volcanoes, shaping landforms like canyons and mountains.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fsurfacechange2025video.mp4?alt=media&token=ac73c746-d5ee-470f-9d84-f04f7a4c0eb8",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fsurfacechange2025song.mp3?alt=media&token=6649da82-6912-4a1a-8016-9a869576e845",
    lyrics: ["(chorus)",
"Now I see a change, you see a change, I see a change, on the surface.",
"They see a change, we see a change, they see a change, on the surface.",

"(verse1)",
"Now, what can affect the changes of the earth’s surface?",
"Let’s see, that’s erosion, erosion.",
"When rocks and soil are broken down and wear down the surface,",
"That’s erosion, erosion.",
"Weathering happens when rocks break apart",
"Due to the weather, mechanical and chemical.",
"Weathering happens when rocks break apart",
"Due to the weather, mechanical and chemical.",
"Mechanical weathering happens when rocks break apart",
"Because of flowing water or ice.",
"Mechanical weathering happens when rocks break apart",
"Because it’s too cold or too hot.",
"In chemical weathering, water dissolves the minerals",
"In the rock and the rock breaks apart.",
"In chemical weathering, water dissolves the minerals",
"In the rock and the rock breaks apart.",

"(chorus)",
"Now I see a change, you see a change, I see a change, on the surface.",
"They see a change, we see a change, they see a change, on the surface.",
"Now I see a change, you see a change, I see a change, on the surface.",
"They see a change, we see a change, they see a change, on the surface.",

"(verse2)",
"A canyon is a valley between cliffs.",
"There’s often a river flowing through it.",
"The river eroded the layers of rocks",
"And weather caused erosion to occur.",
"Mountains sit high, they’re naturally made",
"When the earth’s crust folds into great waves.",
"From lava, a volcanic mountain is made",
"And erosion gives mountains their shape.",
"It can be an earthquake that changes the shape",
"Of the earth’s surface that starts to shake.",
"It can be a volcano that’s opened up",
"From which lava, gases, and rock erupt.",

"(chorus)",
"Now I see a change, you see a change, I see a change, on the surface.",
"They see a change, we see a change, they see a change, on the surface.",
"Now I see a change, you see a change, I see a change, on the surface.",
"They see a change, we see a change, they see a change, on the surface.",

"© Smart Board Learning, LLC. All rights reserved.",],
    gameType: "multipleChoice",
    titleImage: "",
  },
  {
    title: "Weathering",
    slug: "weathering",
    standardNumber: "5.8",
    description: "Earth and Space Systems – Weathering, erosion, and deposition change and shape Earth’s surface by breaking down and moving rocks and soil.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fweathering2025video.mp4?alt=media&token=a9649c8d-b5b6-4180-b9f9-4b1746923164",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fweathering2025song.mp3?alt=media&token=d7242a48-cd46-42b9-8136-1dbab7e492c4",
    lyrics: ["(Chorus)",
"Breaking down Earth’s surface.",
"Breaking down Earth’s surface.",
"By weathering,",
"By erosion.",
"Breaking down Earth’s surface.",
"Breaking down Earth’s surface.",
"By weathering,",
"By erosion.",

"(Verse)",
"Weathering is when the rain and wind,",
"Wears away the Earth’s surface.",

"Erosion is when rocks and soil are broken down,",
"And wears down the Earth’s surface.",

"Deposition is when those broken-down rocks and minerals,",
"Are transported to another place.",

"(Chorus)",
"Breaking down Earth’s surface.",
"Breaking down Earth’s surface.",
"By weathering,",
"By erosion.",
"Breaking down Earth’s surface.",
"Breaking down Earth’s surface.",
"By weathering,",
"By erosion.",

"© Smart Board Learning, LLC. All rights reserved.",],
    gameType: "multipleChoice",
    titleImage: "",
  },
  {
    title: "Natural Resources",
    slug: "naturalresources",
    standardNumber: "5.9",
    description: "Earth Resources – Natural resources can be renewable, nonrenewable, inexhaustible, or recyclable, with examples like trees, coal, sunlight, and aluminum.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fnaturalresources2025video.mp4?alt=media&token=41ca1ac8-d85f-4732-a6e8-31c0c0f5024f",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fnaturalresources2025song.mp3?alt=media&token=970befde-e5f3-490c-b6b6-695a05fbb105",
    lyrics: ["(Chorus)",
"Natural resources are resources,",
"found in nature and used by people.",
"Natural resources are resources,",
"found in nature and used by people.",

"(Verse 1)",
"Renewable resources are trees, fish, and horses.",
"All plants and animals, well,",
"they reproduce and replace themselves.",
"Renewable resources are trees, fish, and horses.",
"All plants and animals, well,",
"they reproduce and replace themselves.",

"Nonrenewable resources are oil, gas, and coal.",
"They take millions of years to form,",
"so, once they’re used up, they’re gone.",
"Nonrenewable resources are oil, gas, and coal.",
"They take millions of years to form,",
"so, once they’re used up, they’re gone.",

"(Chorus)",
"Natural resources are resources,",
"found in nature and used by people.",
"Natural resources are resources,",
"found in nature and used by people.",

"(Verse 2)",
"An inexhaustible resource is sunlight.",
"It will always be around during our lifetime.",
"An inexhaustible resource is sunlight.",
"It will always be around during our lifetime.",

"Recyclable resources can be used more than once.",
"Some of these resources are copper, tin, and aluminum.",
"Recyclable resources can be used more than once.",
"Some of these resources are copper, tin, and aluminum.",

"(Chorus)",
"Natural resources are resources,",
"found in nature and used by people.",
"Natural resources are resources,",
"found in nature and used by people.",

"© Smart Board Learning, LLC. All rights reserved.",],
    gameType: "multipleChoice",
    titleImage: "",
  },
  {
    title: "Fossil Fuels",
    slug: "fossilfuels",
    standardNumber: "5.9",
    description: "Earth Resources – Explains how coal, oil, and natural gas formed over millions of years from plants and animals and why they are nonrenewable energy sources.",
    video: "",
    music: "",
    lyrics: [],
    gameType: "multipleChoice",
    titleImage: "",
  },
  {
    title: "Conserve Water",
    slug: "conservewater",
    standardNumber: "5.9",
    description: "Earth Resources – Learn how to save water by turning off the faucet during daily routines like washing hands and brushing teeth.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fconservewater.mp4?alt=media&token=5978c30d-3564-4c75-b3da-9d87e7d4f5d1",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fconservewater.mp3?alt=media&token=e2e9c115-3b8a-4f62-a190-968298f4ab0e",
    lyrics: ["(chorus)",
"We can conserve water, conserve water, conserve water.",
"We can conserve water, conserve water, conserve water.",

"(verse)",
"By not running the water the whole time, you wash your hands,",
"you wash your hands.",
"By not running the water the whole time, you brush your teeth,",
"you brush your teeth.",
"Wet your hands, put soap on them,",
"turn off the water while you rub the soap in.",
"Then turn the water back on to rinse the soap off.",
"Then, when you’re done turn the water back off.",
"That’s how you can help conserve water.",
"That’s how you can help conserve water.",

"(chorus)",
"We can conserve water, conserve water, conserve water.",
"We can conserve water, conserve water, conserve water.",

"© Smart Board Learning, LLC. All rights reserved.",],
    gameType: "multipleChoice",
    titleImage: "",
  },
  

];
export default topics;